import { useTranslation } from "react-i18next";
import { LocateFixed, Compass, Ruler } from "lucide-react";
import { NeuButton } from "../../../components/neu/Neu";
import { Field } from "../../../components/neu/Field";
import { RADIUS_OPTIONS } from "../branchFields";

// الإحداثيات ونطاق الـ Geofence (مرتبطة بالخريطة أعلاه).
export const GeoFields = ({ form, set }) => {
  const { t } = useTranslation();
  return (
    <>
      <Field
        label={t("branches.latitude")} testId="branch-latitude" type="number" step="any"
        value={form.latitude} onChange={(v) => set("latitude", v)} required
        accent="rose" icon={LocateFixed}
      />
      <Field
        label={t("branches.longitude")} testId="branch-longitude" type="number" step="any"
        value={form.longitude} onChange={(v) => set("longitude", v)} required
        accent="cyan" icon={Compass}
      />
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("branches.radius")}</p>
        <div className="flex flex-wrap gap-2">
          {RADIUS_OPTIONS.map((r) => (
            <NeuButton
              key={r} type="button" data-testid={`branch-radius-${r}`}
              className={`px-4 py-2 ${Number(form.geofence_radius_m) === r ? "text-primary shadow-neu-in" : ""}`}
              onClick={() => set("geofence_radius_m", r)}
            >
              {r} {t("app.meters")}
              {r === 50 ? ` · ${t("branches.recommended")}` : ""}
            </NeuButton>
          ))}
        </div>
        <div className="mt-3 max-w-xs">
          <Field
            label={t("branches.customRadius")} testId="branch-geofence_radius_m" type="number"
            value={form.geofence_radius_m} onChange={(v) => set("geofence_radius_m", v)}
            accent="amber" icon={Ruler}
          />
        </div>
      </div>
    </>
  );
};
